import styled from 'styled-components';

import type { ReactNode } from 'react';
import type { TextProps } from '@visx/text';

import { Text } from '@visx/text';
import { Group } from '@visx/group';

import type { Theme } from '@simplywallst/ui-core';

type Typography = keyof Theme['typography'];

interface Props {
  fill: string;
  typography: Typography;
  children: ReactNode;
}

const StyledGroup = styled(Group)<{
  $typography: Typography;
}>`
  ${({ theme, $typography }) => theme.typography[$typography]}
`;

export const VisxText = ({
  typography,
  children,
  ...props
}: Props & TextProps) => {
  return (
    <StyledGroup $typography={typography}>
      <Text {...props}>{children}</Text>
    </StyledGroup>
  );
};
